export const formatItem = (item: string) =>
  `${item}`.replace(/\s\s+/g, " ").trim();
